// @owners { team: patients-team }
import { ActionSheetContext, MdSpacing, Separator } from '@alto/design-system';
import { type LineItem, LineItemTypeMap } from '@alto/scriptdash/alto/pricing/patients/v3/pricing_endpoint';
import React, { useCallback, useContext } from 'react';
import { getIsGskUser } from '~shared/features/users/selectors/getIsGskUser';
import { parseLineItem } from '~shared/helpers/pricingBreakdown';
import { useSelectorShared } from '~shared/store';
import { FeeDetailsActionSheet } from '../../checkout/components/select-date-card/FeeDetailsActionSheet';
import { PricingInfoRow } from '../../pricing-info/components/PricingInfoRow';

type Props = {
  readonly lineItem: LineItem;
  readonly noSeparator?: boolean;
};

export const PricingBreakdownOrderLineItem = ({ lineItem, noSeparator }: Props) => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);
  const isGSKUser = useSelectorShared(getIsGskUser);
  const { label, originalPrice, shownPrice, savings, hasFee } = parseLineItem(lineItem);
  const hasNextDayMailFee = lineItem.key === LineItemTypeMap.NEXT_DAY_MAIL_FEE && hasFee;
  const showGskFeeInfo = isGSKUser && hasNextDayMailFee;

  const handlePressGskFeeInfo = useCallback(() => {
    setActiveActionSheet(<FeeDetailsActionSheet />);
  }, [setActiveActionSheet]);

  return (
    <>
      <MdSpacing />
      <PricingInfoRow
        label={label}
        originalPrice={originalPrice}
        savings={savings}
        price={shownPrice}
        onPressMoreInfo={showGskFeeInfo ? handlePressGskFeeInfo : undefined}
      />
      <MdSpacing />
      {noSeparator ? null : <Separator />}
    </>
  );
};
